<template lang="pug">
.map
</template>

<script>
import 'leaflet/dist/leaflet.css'
import L from "leaflet"
import Api from "next_report/api"
import AutoRefresh from "next_report/utils/AutoRefresh"

import "leaflet.heat"

const render = (domElement, data, options) => {
  let map
  const baseLayer = L.tileLayer(options.tile_url, {
    attribution: options.attribution,
  })

  const heatmapOptions = options.heatmap

  if (domElement.map == undefined) {
    map = new L.Map(domElement, {
      center: new L.LatLng(options.center[0], options.center[1]),
      zoom: options.center[2],
      layers: [baseLayer],
      maxZoom: 10,
      minZoom: 1,
      zoomControl: true,
      // maxBounds: [ [54.920132, 3.508927], [46.796604, 16.6159167]]
    })
    // map.boxZoom.disable();
    // map.doubleClickZoom.disable();
    map.keyboard.disable()
    map.scrollWheelZoom.disable()
    // map.touchZoom.disable();
    domElement.map = map
  } else {
    map = domElement.map
  }
  const heat = L.heatLayer(data, heatmapOptions).addTo(map)
}

export default {
  mixins: [AutoRefresh],
  props: ["type", "public"],
  watch: {
    type() {
      this.fetch()
    },
  },
  mounted() {
    this.fetch()
  },
  methods: {
    fetch() {
      this.removeLayer()
      if (this.public) {
        Api.get("public_chart/query_form", { type: this.type }).then(
          (response) => {
            render(this.$el, response.data.data, response.data.leafletOptions)
          },
          (error) => {}
        )
      } else {
        Api.fetch(this.type, {}).then(
          (response) => {
            render(this.$el, response.data.data, response.data.leafletOptions)
          },
          (error) => {}
        )
      }
    },
    removeLayer() {
      const { map } = this.$el
      if (map) {
        const heatLayer = Object.values(map._layers).find((el) => el._heat)
        if (heatLayer) {
          map.removeLayer(heatLayer)
        }
      }
    },
  },
}
</script>

<style scoped>
.map {
  z-index: 5;
  min-height: 500px;
  border: 1px solid #999;
}
.leaflet-container .leaflet-control-attribution,
.leaflet-container .leaflet-control-scale {
  font-size: 9px;
  background: transparent;
}
.leaflet-container .leaflet-control-attribution a {
  color: #444;
}
</style>
